import * as Promise from "bluebird";
// Browser
(window as any).Promise = Promise;
